import HomeCarousel from '../../../components/homeCarousel/homeCarousel';
import MobileCarouselCom from '../../../components/mobCarousel/MobileCarousel';
import { adventureData } from '../../../dummyData/adventureData';
import './adventure.css';

const AdventureSection = () => {
    return (
        <>
            <div className='destinationBg' />
            <div className='destinationSection customContainer' id='destinationSection'>
                <div className='alignCenter mobCenter'>
                    <div>
                        <p className='pageCount'>Destinations</p>
                        <p className='homeTitle'>Your Gateway to Adventure</p>
                    </div>
                </div>
                <div className='mobHidden'>
                    <HomeCarousel type={'destination'} data={adventureData} />
                </div>
                <div className='mobDisplay'>
                    <MobileCarouselCom type='destination' data={adventureData} />
                </div>
            </div>
        </>
    );
};

export default AdventureSection;
